import Axios from "axios";
import {
    SET_SALARY_TREND_REPORT_LIST, 
    UNSET_SALARY_TREND_REPORT_LIST
} from "@/store/mutation-types";
import {
    getSalaryTrendReport,
} from "@/store/api";

const state = {
    getSalaryTrendReport: [],
};

const getters = {
    getSalaryTrendReport(state) {
        return state.getSalaryTrendReport;
    },
};

const mutations = {
    [SET_SALARY_TREND_REPORT_LIST](state, data) {
        state.getSalaryTrendReport = data;
    },
    [UNSET_SALARY_TREND_REPORT_LIST](state) {
        state.getSalaryTrendReport = [];
    },
};

const actions = {

    getSalaryTrendReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getSalaryTrendReport}`, { params: data })
                .then((response) => {
                    commit(SET_SALARY_TREND_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_SALARY_TREND_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};